module.exports = __webpack_public_path__ + "media/images/sponsors/sponsor-05-afdd6e3bb328cb5acd3c2f18f752ab35.png";